import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _allowedActionsRequest = {};
var _allowedActionsResponse = {};
var _billingStatus = {
    nextBillingDate: 'google.protobuf.Timestamp',
    previousBillingDate: 'google.protobuf.Timestamp',
    latestPaymentData: '_paymentData',
    freeTrialData: '_freeTrialData',
    updateBillingDateData: '_updateBillingDateData',
    gracePeriodData: '_gracePeriodData',
};
var _bulkUpdateSubscriptionItemsByFilterRequest = {
    scheduleAdditionalInfo: '_scheduleAdditionalInfo',
};
var _bulkUpdateSubscriptionItemsByFilterResponse = {};
var _cancellationInfo = { cancellationDate: 'google.protobuf.Timestamp' };
var _cancelSubscriptionRequest = {};
var _cancelSubscriptionResponse = { subscription: '_subscription' };
var _charge = { cycleBillingDate: 'google.protobuf.Timestamp' };
var _countSubscriptionsRequest = {};
var _countSubscriptionsResponse = {};
var _createSubscriptionRequest = { subscription: '_subscription' };
var _createSubscriptionResponse = { subscription: '_subscription' };
var _customerAllowedActionsRequest = {};
var _customerAllowedActionsResponse = {};
var _customerCancelSubscriptionRequest = {};
var _customerCancelSubscriptionResponse = { subscription: '_subscription' };
var _customerExtendSubscriptionRequest = {};
var _customerExtendSubscriptionResponse = { subscription: '_subscription' };
var _customerListUpcomingChargesRequest = {};
var _customerListUpcomingChargesResponse = {
    upcomingCharge: '_subscriptionCharge',
};
var _customerTurnOffAutoRenewalRequest = {};
var _customerTurnOffAutoRenewalResponse = { subscription: '_subscription' };
var _customerTurnOnAutoRenewalRequest = {};
var _customerTurnOnAutoRenewalResponse = { subscription: '_subscription' };
var _deleteSubscriptionRequest = {};
var _deleteSubscriptionResponse = {};
var _empty = {};
var _extendSubscriptionRequest = {};
var _extendSubscriptionResponse = { subscription: '_subscription' };
var _freeTrailEnded = { subscription: '_subscription' };
var _freeTrailStarted = { subscription: '_subscription' };
var _freeTrialData = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _futureUpdatesRequested = { subscription: '_subscription' };
var _getSubscriptionRequest = {};
var _getSubscriptionResponse = { subscription: '_subscription' };
var _getSubscriptionsStatsRequest = {};
var _getSubscriptionsStatsResponse = {};
var _gracePeriodData = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _gracePeriodEnded = { subscription: '_subscription' };
var _gracePeriodStarted = { subscription: '_subscription' };
var _initiatePaymentMethodSetupRequest = {};
var _initiatePaymentMethodSetupResponse = {};
var _latestInvoiceMarkedAsPaid = { subscription: '_subscription' };
var _listSubscriptionHistoryRequest = {};
var _listSubscriptionHistoryResponse = {
    historyEntries: '_subscriptionHistoryEntry',
};
var _listUpcomingChargesRequest = {
    nextBillingDate: 'google.protobuf.Timestamp',
};
var _listUpcomingChargesResponse = { upcomingCharges: '_subscriptionCharge' };
var _markLatestInvoiceAsPaidRequest = {};
var _markLatestInvoiceAsPaidResponse = { subscription: '_subscription' };
var _pauseInfo = {
    startDate: 'google.protobuf.Timestamp',
    resumeDate: 'google.protobuf.Timestamp',
};
var _pauseSubscriptionRequest = {
    pauseAtSchedule: '_scheduleAdditionalInfo',
    autoResumeAtSchedule: '_scheduleAdditionalInfo',
};
var _pauseSubscriptionRequested = { subscription: '_subscription' };
var _pauseSubscriptionResponse = { subscription: '_subscription' };
var _payCycleRequest = {};
var _payCycleResponse = { subscription: '_subscription' };
var _paymentData = { initialFailedPaymentDate: 'google.protobuf.Timestamp' };
var _paymentMethodUpdated = { subscription: '_subscription' };
var _previewSubscriptionChargesRequest = {
    subscriptionInfo: '_subscriptionInfo',
};
var _previewSubscriptionChargesResponse = { charges: '_charge' };
var _previewSubscriptionsChargesRequest = {
    subscriptionsBillingDetails: '_subscriptionBillingDetails',
};
var _previewSubscriptionsChargesResponse = {
    subscriptionsCharges: '_subscriptionCharges',
};
var _querySubscriptionsRequest = {};
var _querySubscriptionsResponse = { subscriptions: '_subscription' };
var _resetPendingUpdates = { subscription: '_subscription' };
var _resumeSubscriptionRequest = {
    resumeAtSchedule: '_scheduleAdditionalInfo',
};
var _resumeSubscriptionRequested = { subscription: '_subscription' };
var _resumeSubscriptionResponse = { subscription: '_subscription' };
var _reviseSubscriptionRequest = {};
var _reviseSubscriptionResponse = { subscription: '_subscription' };
var _runTimeCapsuleTaskNowRequest = {};
var _scheduleAdditionalInfo = { specificDate: 'google.protobuf.Timestamp' };
var _scheduledPauseCanceled = { subscription: '_subscription' };
var _scheduledResumeCanceled = { subscription: '_subscription' };
var _searchSubscriptionsRequest = {};
var _searchSubscriptionsResponse = { subscriptions: '_subscription' };
var _specificDateSubscriptionUpdateData = {
    executionDate: 'google.protobuf.Timestamp',
};
var _subscription = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
    billingStatus: '_billingStatus',
    pauseInfo: '_pauseInfo',
    cancellationInfo: '_cancellationInfo',
    specificDatePendingUpdateData: '_specificDateSubscriptionUpdateData',
};
var _subscriptionActivated = { subscription: '_subscription' };
var _subscriptionAutoRenewalTurnedOff = { subscription: '_subscription' };
var _subscriptionAutoRenewalTurnedOn = { subscription: '_subscription' };
var _subscriptionBackOfficeAction = { subscription: '_subscription' };
var _subscriptionBillingCycleStarted = { subscription: '_subscription' };
var _subscriptionBillingDateUpdated = {
    billingDate: 'google.protobuf.Timestamp',
    subscription: '_subscription',
};
var _subscriptionBillingDetails = { startDate: 'google.protobuf.Timestamp' };
var _subscriptionCanceled = { subscription: '_subscription' };
var _subscriptionCharge = { billingDate: 'google.protobuf.Timestamp' };
var _subscriptionCharges = { charges: '_charge' };
var _subscriptionCollectionMethodUpdated = { subscription: '_subscription' };
var _subscriptionCycleReadyToPay = { subscription: '_subscription' };
var _subscriptionEnded = { subscription: '_subscription' };
var _subscriptionExtended = { subscription: '_subscription' };
var _subscriptionHistoryEntry = {
    entryTime: 'google.protobuf.Timestamp',
    event: '_v1SubscriptionEvent',
};
var _subscriptionInfo = { startDate: 'google.protobuf.Timestamp' };
var _subscriptionInitialPurchaseCompleted = { subscription: '_subscription' };
var _subscriptionPaused = { subscription: '_subscription' };
var _subscriptionResumed = { subscription: '_subscription' };
var _subscriptionRevived = { subscription: '_subscription' };
var _turnOffSubscriptionAutoRenewalRequest = {};
var _turnOffSubscriptionAutoRenewalResponse = {
    subscription: '_subscription',
};
var _turnOnSubscriptionAutoRenewalRequest = {};
var _turnOnSubscriptionAutoRenewalResponse = {
    subscription: '_subscription',
};
var _updateBillingDateData = { paidUntil: 'google.protobuf.Timestamp' };
var _updatesApplied = { subscription: '_subscription' };
var _updateSubscriptionBillingDateRequest = {
    billingDate: 'google.protobuf.Timestamp',
};
var _updateSubscriptionBillingDateResponse = {
    subscription: '_subscription',
};
var _updateSubscriptionItemsRequest = {
    scheduleAdditionalInfo: '_scheduleAdditionalInfo',
};
var _updateSubscriptionItemsResponse = { subscription: '_subscription' };
var _updateSubscriptionOriginRequest = {};
var _updateSubscriptionOriginResponse = { subscription: '_subscription' };
var _updateSubscriptionPaymentMethodRequest = {};
var _updateSubscriptionPaymentMethodResponse = {
    subscription: '_subscription',
};
var _updateSubscriptionPoliciesRequest = {};
var _updateSubscriptionPoliciesResponse = {};
var _updateSubscriptionRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    subscription: '_subscription',
};
var _updateSubscriptionResponse = { subscription: '_subscription' };
var _updateSubscriptionStartDateRequest = {
    startDate: 'google.protobuf.Timestamp',
};
var _updateSubscriptionStartDateResponse = { subscription: '_subscription' };
var _v1SubscriptionCreated = { subscription: '_subscription' };
var _v1SubscriptionEvent = {
    created: '_v1SubscriptionCreated',
    updated: '_v1SubscriptionUpdated',
    activated: '_subscriptionActivated',
    ended: '_subscriptionEnded',
    canceled: '_subscriptionCanceled',
    paused: '_subscriptionPaused',
    resumed: '_subscriptionResumed',
    pauseRequested: '_pauseSubscriptionRequested',
    resumeRequested: '_resumeSubscriptionRequested',
    scheduledPauseCanceled: '_scheduledPauseCanceled',
    scheduledResumeCanceled: '_scheduledResumeCanceled',
    billingCycleStarted: '_subscriptionBillingCycleStarted',
    autoRenewalTurnedOn: '_subscriptionAutoRenewalTurnedOn',
    autoRenewalTurnedOff: '_subscriptionAutoRenewalTurnedOff',
    cycleReadyToPay: '_subscriptionCycleReadyToPay',
    extended: '_subscriptionExtended',
    initialPurchaseCompleted: '_subscriptionInitialPurchaseCompleted',
    latestInvoiceMarkedAsPaid: '_latestInvoiceMarkedAsPaid',
    revived: '_subscriptionRevived',
    billingDateUpdated: '_subscriptionBillingDateUpdated',
    futureUpdatesRequested: '_futureUpdatesRequested',
    updatesApplied: '_updatesApplied',
    resetPendingUpdates: '_resetPendingUpdates',
    gracePeriodStarted: '_gracePeriodStarted',
    gracePeriodEnded: '_gracePeriodEnded',
    paymentMethodUpdated: '_paymentMethodUpdated',
    collectionMethodUpdated: '_subscriptionCollectionMethodUpdated',
    freeTrailStarted: '_freeTrailStarted',
    freeTrailEnded: '_freeTrailEnded',
    subscriptionBoAction: '_subscriptionBackOfficeAction',
};
var _v1SubscriptionUpdated = {
    current: '_subscription',
    previous: '_subscription',
};
function resolveComWixpressBillingSubscriptionsApiV1SubscriptionsBackOfficeServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBillingSubscriptionsApiV1CustomerSubscriptionsServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBillingSubscriptionsApiV1SubscriptionHistoryServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/billing-subscriptions',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function listSubscriptionHistory(payload) {
    var _a = serializer(_listSubscriptionHistoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listSubscriptionHistoryResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrailEnded: _freeTrailEnded,
        _freeTrailStarted: _freeTrailStarted,
        _freeTrialData: _freeTrialData,
        _futureUpdatesRequested: _futureUpdatesRequested,
        _gracePeriodData: _gracePeriodData,
        _gracePeriodEnded: _gracePeriodEnded,
        _gracePeriodStarted: _gracePeriodStarted,
        _latestInvoiceMarkedAsPaid: _latestInvoiceMarkedAsPaid,
        _pauseInfo: _pauseInfo,
        _pauseSubscriptionRequested: _pauseSubscriptionRequested,
        _paymentData: _paymentData,
        _paymentMethodUpdated: _paymentMethodUpdated,
        _resetPendingUpdates: _resetPendingUpdates,
        _resumeSubscriptionRequested: _resumeSubscriptionRequested,
        _scheduledPauseCanceled: _scheduledPauseCanceled,
        _scheduledResumeCanceled: _scheduledResumeCanceled,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _subscriptionActivated: _subscriptionActivated,
        _subscriptionAutoRenewalTurnedOff: _subscriptionAutoRenewalTurnedOff,
        _subscriptionAutoRenewalTurnedOn: _subscriptionAutoRenewalTurnedOn,
        _subscriptionBackOfficeAction: _subscriptionBackOfficeAction,
        _subscriptionBillingCycleStarted: _subscriptionBillingCycleStarted,
        _subscriptionBillingDateUpdated: _subscriptionBillingDateUpdated,
        _subscriptionCanceled: _subscriptionCanceled,
        _subscriptionCollectionMethodUpdated: _subscriptionCollectionMethodUpdated,
        _subscriptionCycleReadyToPay: _subscriptionCycleReadyToPay,
        _subscriptionEnded: _subscriptionEnded,
        _subscriptionExtended: _subscriptionExtended,
        _subscriptionHistoryEntry: _subscriptionHistoryEntry,
        _subscriptionInitialPurchaseCompleted: _subscriptionInitialPurchaseCompleted,
        _subscriptionPaused: _subscriptionPaused,
        _subscriptionResumed: _subscriptionResumed,
        _subscriptionRevived: _subscriptionRevived,
        _updateBillingDateData: _updateBillingDateData,
        _updatesApplied: _updatesApplied,
        _v1SubscriptionCreated: _v1SubscriptionCreated,
        _v1SubscriptionEvent: _v1SubscriptionEvent,
        _v1SubscriptionUpdated: _v1SubscriptionUpdated,
    }).fromJSON;
    function __listSubscriptionHistory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'GET',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionHistoryService.ListSubscriptionHistory',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionHistoryServiceUrl({
                protoPath: '/v1/subscriptions/{subscriptionId}/history',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listSubscriptionHistory.fromReq = fromReq;
    __listSubscriptionHistory.__isAmbassador = true;
    return __listSubscriptionHistory;
}
/** Identity must be a site member and customer subscription belongs to */
export function customerGetSubscription(payload) {
    var _a = serializer(_getSubscriptionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSubscriptionResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __customerGetSubscription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'GET',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.CustomerSubscriptionsService.GetSubscription',
            url: resolveComWixpressBillingSubscriptionsApiV1CustomerSubscriptionsServiceUrl({
                protoPath: '/v1/customer_subscriptions/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __customerGetSubscription.fromReq = fromReq;
    __customerGetSubscription.__isAmbassador = true;
    return __customerGetSubscription;
}
/** Identity must be a site member and customer subscription belongs to */
export function customerCancelSubscription(payload) {
    var _a = serializer(_customerCancelSubscriptionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_customerCancelSubscriptionResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __customerCancelSubscription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.CustomerSubscriptionsService.CancelSubscription',
            url: resolveComWixpressBillingSubscriptionsApiV1CustomerSubscriptionsServiceUrl({
                protoPath: '/v1/customer_subscriptions/{id}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __customerCancelSubscription.fromReq = fromReq;
    __customerCancelSubscription.__isAmbassador = true;
    return __customerCancelSubscription;
}
/** Identity must be a site member and customer subscription belongs to */
export function customerTurnOnSubscriptionAutoRenewal(payload) {
    var _a = serializer(_customerTurnOnAutoRenewalRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_customerTurnOnAutoRenewalResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __customerTurnOnSubscriptionAutoRenewal(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.CustomerSubscriptionsService.TurnOnSubscriptionAutoRenewal',
            url: resolveComWixpressBillingSubscriptionsApiV1CustomerSubscriptionsServiceUrl({
                protoPath: '/v1/customer_subscriptions/{id}/turn_on_auto_renewal',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __customerTurnOnSubscriptionAutoRenewal.fromReq = fromReq;
    __customerTurnOnSubscriptionAutoRenewal.__isAmbassador = true;
    return __customerTurnOnSubscriptionAutoRenewal;
}
/** Identity must be a site member and customer subscription belongs to */
export function customerTurnOffSubscriptionAutoRenewal(payload) {
    var _a = serializer(_customerTurnOffAutoRenewalRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_customerTurnOffAutoRenewalResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __customerTurnOffSubscriptionAutoRenewal(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.CustomerSubscriptionsService.TurnOffSubscriptionAutoRenewal',
            url: resolveComWixpressBillingSubscriptionsApiV1CustomerSubscriptionsServiceUrl({
                protoPath: '/v1/customer_subscriptions/{id}/turn_off_auto_renewal',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __customerTurnOffSubscriptionAutoRenewal.fromReq = fromReq;
    __customerTurnOffSubscriptionAutoRenewal.__isAmbassador = true;
    return __customerTurnOffSubscriptionAutoRenewal;
}
export function customerExtendSubscription(payload) {
    var _a = serializer(_customerExtendSubscriptionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_customerExtendSubscriptionResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __customerExtendSubscription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'PATCH',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.CustomerSubscriptionsService.ExtendSubscription',
            url: resolveComWixpressBillingSubscriptionsApiV1CustomerSubscriptionsServiceUrl({
                protoPath: '/v1/customer_subscriptions/{id}/extend',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __customerExtendSubscription.fromReq = fromReq;
    __customerExtendSubscription.__isAmbassador = true;
    return __customerExtendSubscription;
}
/** identity must be a site member */
export function customerQuerySubscriptions(payload) {
    var _a = serializer(_querySubscriptionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_querySubscriptionsResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __customerQuerySubscriptions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.CustomerSubscriptionsService.QuerySubscriptions',
            url: resolveComWixpressBillingSubscriptionsApiV1CustomerSubscriptionsServiceUrl({
                protoPath: '/v1/customer_subscriptions/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __customerQuerySubscriptions.fromReq = fromReq;
    __customerQuerySubscriptions.__isAmbassador = true;
    return __customerQuerySubscriptions;
}
/** identity must be a site member */
export function customerCountSubscriptions(payload) {
    var _a = serializer(_countSubscriptionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countSubscriptionsResponse, {}).fromJSON;
    function __customerCountSubscriptions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.CustomerSubscriptionsService.CountSubscriptions',
            url: resolveComWixpressBillingSubscriptionsApiV1CustomerSubscriptionsServiceUrl({
                protoPath: '/v1/customer_subscriptions/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __customerCountSubscriptions.fromReq = fromReq;
    __customerCountSubscriptions.__isAmbassador = true;
    return __customerCountSubscriptions;
}
/**
 * Update subscription's payment method.
 * Supported only for recurring subscriptions or one time subscriptions during free trial.
 */
export function customerUpdateSubscriptionPaymentMethod(payload) {
    var _a = serializer(_updateSubscriptionPaymentMethodRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSubscriptionPaymentMethodResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __customerUpdateSubscriptionPaymentMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'PATCH',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.CustomerSubscriptionsService.UpdateSubscriptionPaymentMethod',
            url: resolveComWixpressBillingSubscriptionsApiV1CustomerSubscriptionsServiceUrl({
                protoPath: '/v1/customer_subscriptions/{id}/payment_method',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __customerUpdateSubscriptionPaymentMethod.fromReq = fromReq;
    __customerUpdateSubscriptionPaymentMethod.__isAmbassador = true;
    return __customerUpdateSubscriptionPaymentMethod;
}
export function customerAllowedActions(payload) {
    var _a = serializer(_customerAllowedActionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_customerAllowedActionsResponse, {}).fromJSON;
    function __customerAllowedActions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'GET',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.CustomerSubscriptionsService.AllowedActions',
            url: resolveComWixpressBillingSubscriptionsApiV1CustomerSubscriptionsServiceUrl({
                protoPath: '/v1/customer_subscriptions/{id}/allowed_actions',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __customerAllowedActions.fromReq = fromReq;
    __customerAllowedActions.__isAmbassador = true;
    return __customerAllowedActions;
}
/** List future subscriptions charges. */
export function customerListUpcomingCharges(payload) {
    var _a = serializer(_customerListUpcomingChargesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_customerListUpcomingChargesResponse, { _subscriptionCharge: _subscriptionCharge }).fromJSON;
    function __customerListUpcomingCharges(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'GET',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.CustomerSubscriptionsService.ListUpcomingCharges',
            url: resolveComWixpressBillingSubscriptionsApiV1CustomerSubscriptionsServiceUrl({
                protoPath: '/v1/customer_subscriptions/{id}/upcoming_charges',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __customerListUpcomingCharges.fromReq = fromReq;
    __customerListUpcomingCharges.__isAmbassador = true;
    return __customerListUpcomingCharges;
}
/** Creates auto-charge order that can be paid by customer */
export function customerInitiatePaymentMethodSetup(payload) {
    var _a = serializer(_initiatePaymentMethodSetupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_initiatePaymentMethodSetupResponse, {}).fromJSON;
    function __customerInitiatePaymentMethodSetup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.CustomerSubscriptionsService.InitiatePaymentMethodSetup',
            url: resolveComWixpressBillingSubscriptionsApiV1CustomerSubscriptionsServiceUrl({
                protoPath: '/v1/customer_subscriptions/{id}/payment_method_setup',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __customerInitiatePaymentMethodSetup.fromReq = fromReq;
    __customerInitiatePaymentMethodSetup.__isAmbassador = true;
    return __customerInitiatePaymentMethodSetup;
}
/**
 * Creates a subscription and returns payment order id to pay for non-free subscription.
 * Only Service identity is allowed in order to create subscription. Mandatory origin fields are filled based on it.
 * So the calls should be server-signed.
 */
export function createSubscription(payload) {
    var _a = serializer(_createSubscriptionRequest, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createSubscriptionResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __createSubscription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.CreateSubscription',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSubscription.fromReq = fromReq;
    __createSubscription.__isAmbassador = true;
    return __createSubscription;
}
/** Returns a single subscription by its id */
export function getSubscription(payload) {
    var _a = serializer(_getSubscriptionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSubscriptionResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __getSubscription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'GET',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.GetSubscription',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSubscription.fromReq = fromReq;
    __getSubscription.__isAmbassador = true;
    return __getSubscription;
}
/** Updates subscription. Supported only for customer and billingSettings.paymentMethod fields */
export function updateSubscription(payload) {
    var _a = serializer(_updateSubscriptionRequest, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSubscriptionResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __updateSubscription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'PATCH',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.UpdateSubscription',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{subscription.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSubscription.fromReq = fromReq;
    __updateSubscription.__isAmbassador = true;
    return __updateSubscription;
}
export function updateSubscriptionStartDate(payload) {
    var _a = serializer(_updateSubscriptionStartDateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSubscriptionStartDateResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __updateSubscriptionStartDate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'PATCH',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.UpdateSubscriptionStartDate',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}/start_date',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSubscriptionStartDate.fromReq = fromReq;
    __updateSubscriptionStartDate.__isAmbassador = true;
    return __updateSubscriptionStartDate;
}
/**
 * Update subscription's payment method.
 * Supported only for recurring subscriptions or one time subscriptions during free trial.
 */
export function updateSubscriptionPaymentMethod(payload) {
    var _a = serializer(_updateSubscriptionPaymentMethodRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSubscriptionPaymentMethodResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __updateSubscriptionPaymentMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'PATCH',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.UpdateSubscriptionPaymentMethod',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}/payment_method',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSubscriptionPaymentMethod.fromReq = fromReq;
    __updateSubscriptionPaymentMethod.__isAmbassador = true;
    return __updateSubscriptionPaymentMethod;
}
/** Updates subscription's policies */
export function updateSubscriptionPolicies(payload) {
    var _a = serializer(_updateSubscriptionPoliciesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSubscriptionPoliciesResponse, {}).fromJSON;
    function __updateSubscriptionPolicies(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'PATCH',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.UpdateSubscriptionPolicies',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}/policies',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSubscriptionPolicies.fromReq = fromReq;
    __updateSubscriptionPolicies.__isAmbassador = true;
    return __updateSubscriptionPolicies;
}
/**
 * Updates the next billing date for a subscription.
 *
 *
 * Updating the billing date may add a proration charge or credit to the next
 * invoice. The customer must pay more in case you extend the current billing
 * cycle. They pay less in case you shorten the current billing cycle. You can
 * choose whether BASS automatically calculates the proration amount based on
 * the number of days added to or removed from the current billing cycle.
 * Alternatively, you can pass a proration amount based on your own custom
 * calculation. The custom proration amount can't exceed the total of the
 * current billing cycle.
 */
export function updateSubscriptionBillingDate(payload) {
    var _a = serializer(_updateSubscriptionBillingDateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSubscriptionBillingDateResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __updateSubscriptionBillingDate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'PATCH',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.UpdateSubscriptionBillingDate',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}/update-billing-date',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSubscriptionBillingDate.fromReq = fromReq;
    __updateSubscriptionBillingDate.__isAmbassador = true;
    return __updateSubscriptionBillingDate;
}
/** Update subscription's origin. */
export function updateSubscriptionOrigin(payload) {
    var _a = serializer(_updateSubscriptionOriginRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSubscriptionOriginResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __updateSubscriptionOrigin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'PATCH',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.UpdateSubscriptionOrigin',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}/update-origin',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSubscriptionOrigin.fromReq = fromReq;
    __updateSubscriptionOrigin.__isAmbassador = true;
    return __updateSubscriptionOrigin;
}
/** Revises a draft subscription */
export function reviseSubscription(payload) {
    var _a = serializer(_reviseSubscriptionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reviseSubscriptionResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __reviseSubscription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.ReviseSubscription',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reviseSubscription.fromReq = fromReq;
    __reviseSubscription.__isAmbassador = true;
    return __reviseSubscription;
}
/** Updates subscription items */
export function updateSubscriptionItems(payload) {
    var _a = serializer(_updateSubscriptionItemsRequest, { _scheduleAdditionalInfo: _scheduleAdditionalInfo }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSubscriptionItemsResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __updateSubscriptionItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'PATCH',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.UpdateSubscriptionItems',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}/items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSubscriptionItems.fromReq = fromReq;
    __updateSubscriptionItems.__isAmbassador = true;
    return __updateSubscriptionItems;
}
/**
 * Bulk updates subscription items, given the provided filtering.
 *
 *
 * Use `subscriptionFilter` to select which subscriptions are updated and
 * `catalogReferenceIds` to specify which items from these subscriptions are
 * updated. Note that the `catalogReferenceIds` filter is based on the catalog
 * item ID and not each item's unique ID. The call fails in case you send an
 * empty `subscriptionFilter`.
 *
 * For field support in `subscriptionFilter` see
 * [Search and Query: Bulk Update Subscription Items By Filter](https://bo.wix.com/wix-docs/rest/drafts/subscriptions-by-billing-by-wix/search-and-query#drafts_subscriptions-by-billing-by-wix_search-and-query_bulk-update-subscription-items-by-filter).
 * To learn about working with filters in general, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
 *
 * The `updateAction` field let's you update subscription items immediately,
 * at the beginning of the next billing cycle, or on a future date of your
 * choice. Alternatively, you can cancel all currently scheduled updates for the
 * specified subscriptions by passing `{"updateAction": "RESET_PENDING_UPDATES"}`.
 * Then, use only the `subscriptionId` field inside `subscriptionFilter` since
 * passing any other subscription filter results in a failed validation error.
 *
 * You can update the item price, quantity, and tax. To do so, pass the
 * relevant data inside the `bulkItemUpdateData` object. All item fields are
 * updated to the same values. In case you want to set different values for
 * individual items, you must call _Bulk Update Subscription Items By Filter_
 * multiple times, once per unique update.
 *
 * Note that you can't use the `itemsToAdd` object yet, since it results
 * in a validation failure at the moment.
 *
 * In case you schedule updates for a future point in time, the changes are
 * reflected in the subscription's `pendingUpdateData.itemsToUpdate` array.
 * They will be reflected in the subscription's relevant item once they become
 * effective. At the same time, they will also be removed from
 * `pendingUpdateData.itemsToUpdate`.
 *
 * You can retrieve information about the status of the bulk job from
 * [Async Infra](https://pbo.wix.com/fire-console/?artifact=com.wixpress.asyncinfra.async-job-service&service=wix.infra.asyncjobs.v1.AsyncJobService&method=ListAsyncJobItems&body=eyJqb2JfaWQiOiIifQ%3D%3D).
 */
export function bulkUpdateSubscriptionItemsByFilter(payload) {
    var _a = serializer(_bulkUpdateSubscriptionItemsByFilterRequest, { _scheduleAdditionalInfo: _scheduleAdditionalInfo }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateSubscriptionItemsByFilterResponse, {}).fromJSON;
    function __bulkUpdateSubscriptionItemsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'PATCH',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.BulkUpdateSubscriptionItemsByFilter',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/bulk/subscriptions/update-items-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateSubscriptionItemsByFilter.fromReq = fromReq;
    __bulkUpdateSubscriptionItemsByFilter.__isAmbassador = true;
    return __bulkUpdateSubscriptionItemsByFilter;
}
/** Deletes subscription */
export function deleteSubscription(payload) {
    var _a = serializer(_deleteSubscriptionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteSubscriptionResponse, {}).fromJSON;
    function __deleteSubscription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'DELETE',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.DeleteSubscription',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteSubscription.fromReq = fromReq;
    __deleteSubscription.__isAmbassador = true;
    return __deleteSubscription;
}
/**
 * Cancels subscription immediately. Can be canceled by member if subscription policy allows it
 * Only PENDING, ACTIVE or PAUSED subscriptions can be canceled
 */
export function cancelSubscription(payload) {
    var _a = serializer(_cancelSubscriptionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelSubscriptionResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __cancelSubscription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.CancelSubscription',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelSubscription.fromReq = fromReq;
    __cancelSubscription.__isAmbassador = true;
    return __cancelSubscription;
}
/** Pauses subscription now or in future. Possible to pause also payments schedule. */
export function pauseSubscription(payload) {
    var _a = serializer(_pauseSubscriptionRequest, { _scheduleAdditionalInfo: _scheduleAdditionalInfo }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_pauseSubscriptionResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __pauseSubscription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.PauseSubscription',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}/pause',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __pauseSubscription.fromReq = fromReq;
    __pauseSubscription.__isAmbassador = true;
    return __pauseSubscription;
}
/** Resumes paused subscription now or in future. */
export function resumeSubscription(payload) {
    var _a = serializer(_resumeSubscriptionRequest, { _scheduleAdditionalInfo: _scheduleAdditionalInfo }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resumeSubscriptionResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __resumeSubscription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.ResumeSubscription',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}/resume',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resumeSubscription.fromReq = fromReq;
    __resumeSubscription.__isAmbassador = true;
    return __resumeSubscription;
}
/**
 * Lists subscriptions based on specified filters.
 * By default non-draft subscriptions returned.
 */
export function querySubscriptions(payload) {
    var _a = serializer(_querySubscriptionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_querySubscriptionsResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __querySubscriptions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.QuerySubscriptions',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __querySubscriptions.fromReq = fromReq;
    __querySubscriptions.__isAmbassador = true;
    return __querySubscriptions;
}
export function searchSubscriptions(payload) {
    var _a = serializer(_searchSubscriptionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchSubscriptionsResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __searchSubscriptions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.SearchSubscriptions',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchSubscriptions.fromReq = fromReq;
    __searchSubscriptions.__isAmbassador = true;
    return __searchSubscriptions;
}
/**
 * Counts subscriptions given the provided filters. Returns the total number
 * of subscriptions matching the filters and a count per status.
 *
 *
 * You can either pass a list of statuses or a `statusGroup`, which is a
 * pre-defined combination of statuses.
 *
 * If you don't provide any filters, all subscription statuses with the
 * exception of `"DRAFT"` are counted.
 *
 * You may also specify a `customerId` as filter. Then, only subscriptions for
 * this customer are counted. When providing a `customerId`, you must also
 * specify a `paymentMethodId`.
 */
export function countSubscriptions(payload) {
    var _a = serializer(_countSubscriptionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countSubscriptionsResponse, {}).fromJSON;
    function __countSubscriptions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.CountSubscriptions',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countSubscriptions.fromReq = fromReq;
    __countSubscriptions.__isAmbassador = true;
    return __countSubscriptions;
}
/**
 * Turn on auto-renew subscription in case auto-renew was turned off. The operation changes back cycle_auto_renew
 * to true, which will ensure subscription billing will continue. Also cancellation info holding information about
 * auto renew off will be cleared.
 */
export function turnOnSubscriptionAutoRenewal(payload) {
    var _a = serializer(_turnOnSubscriptionAutoRenewalRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_turnOnSubscriptionAutoRenewalResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __turnOnSubscriptionAutoRenewal(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'PATCH',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.TurnOnSubscriptionAutoRenewal',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}/turn_on_auto_renewal',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __turnOnSubscriptionAutoRenewal.fromReq = fromReq;
    __turnOnSubscriptionAutoRenewal.__isAmbassador = true;
    return __turnOnSubscriptionAutoRenewal;
}
/**
 * Turn off auto-renew of subscription. At next billing date subscription will be canceled.
 * Billing settings flag cycle_auto_renew is set to false and information about this operation stored
 * in cancellation info for future usage in cancellation.
 */
export function turnOffSubscriptionAutoRenewal(payload) {
    var _a = serializer(_turnOffSubscriptionAutoRenewalRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_turnOffSubscriptionAutoRenewalResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __turnOffSubscriptionAutoRenewal(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'PATCH',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.TurnOffSubscriptionAutoRenewal',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}/turn_off_auto_renewal',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __turnOffSubscriptionAutoRenewal.fromReq = fromReq;
    __turnOffSubscriptionAutoRenewal.__isAmbassador = true;
    return __turnOffSubscriptionAutoRenewal;
}
/**
 * Marks the last invoice as paid used for the following scenarios:
 * * Offline subscriptions.
 * * Online subscriptions during grace period. The operation will convert invoice to offline, remove grace period
 * and will send BillingCycleStarted event after invoice closing.
 * * Online one time payment subscription with total price of zero during purchase flow.
 * Activated event will be sent after invoice closing and subscription will be activated.
 */
export function markLatestInvoiceAsPaid(payload) {
    var _a = serializer(_markLatestInvoiceAsPaidRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markLatestInvoiceAsPaidResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __markLatestInvoiceAsPaid(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.MarkLatestInvoiceAsPaid',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{subscriptionId}/mark-latest-invoice-as-paid',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markLatestInvoiceAsPaid.fromReq = fromReq;
    __markLatestInvoiceAsPaid.__isAmbassador = true;
    return __markLatestInvoiceAsPaid;
}
/** Returns number of subscriptions in each state. */
export function getSubscriptionsStats(payload) {
    var _a = serializer(_getSubscriptionsStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSubscriptionsStatsResponse, {}).fromJSON;
    function __getSubscriptionsStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'GET',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.GetSubscriptionsStats',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/stats',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSubscriptionsStats.fromReq = fromReq;
    __getSubscriptionsStats.__isAmbassador = true;
    return __getSubscriptionsStats;
}
/** Extends subscription by moving end date with or without billing cycles addition. */
export function extendSubscription(payload) {
    var _a = serializer(_extendSubscriptionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_extendSubscriptionResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __extendSubscription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'PATCH',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.ExtendSubscription',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}/extend',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __extendSubscription.fromReq = fromReq;
    __extendSubscription.__isAmbassador = true;
    return __extendSubscription;
}
export function allowedActions(payload) {
    var _a = serializer(_allowedActionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_allowedActionsResponse, {}).fromJSON;
    function __allowedActions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'GET',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.AllowedActions',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}/allowed_actions',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __allowedActions.fromReq = fromReq;
    __allowedActions.__isAmbassador = true;
    return __allowedActions;
}
/** List future subscriptions charges */
export function listUpcomingCharges(payload) {
    var _a = serializer(_listUpcomingChargesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listUpcomingChargesResponse, {
        _subscriptionCharge: _subscriptionCharge,
    }).fromJSON;
    function __listUpcomingCharges(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'GET',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.ListUpcomingCharges',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{subscriptionId}/upcoming_charges',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listUpcomingCharges.fromReq = fromReq;
    __listUpcomingCharges.__isAmbassador = true;
    return __listUpcomingCharges;
}
/**
 * Retrieves the preview of subscription charges.
 * Returns all the charges applicable to a subscription based on the provided subscription information.
 * @deprecated It has been replaced with com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.PreviewSubscriptionsCharges(), and will be removed on 2025-06-30.
 */
export function previewSubscriptionCharges(payload) {
    var _a = serializer(_previewSubscriptionChargesRequest, { _subscriptionInfo: _subscriptionInfo }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewSubscriptionChargesResponse, { _charge: _charge }).fromJSON;
    function __previewSubscriptionCharges(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'GET',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.PreviewSubscriptionCharges',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/preview_charges',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewSubscriptionCharges.fromReq = fromReq;
    __previewSubscriptionCharges.__isAmbassador = true;
    return __previewSubscriptionCharges;
}
/**
 * Retrieves the preview of subscription charges for a bulk of subscriptions.
 * Returns all the charges applicable to all subscriptions, based on the provided subscriptions information.
 */
export function previewSubscriptionsCharges(payload) {
    var _a = serializer(_previewSubscriptionsChargesRequest, { _subscriptionBillingDetails: _subscriptionBillingDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_previewSubscriptionsChargesResponse, { _charge: _charge, _subscriptionCharges: _subscriptionCharges }).fromJSON;
    function __previewSubscriptionsCharges(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'GET',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.PreviewSubscriptionsCharges',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/preview-subscriptions-charges',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __previewSubscriptionsCharges.fromReq = fromReq;
    __previewSubscriptionsCharges.__isAmbassador = true;
    return __previewSubscriptionsCharges;
}
/** Creates authorization invoice with Moto settings in order to create */
export function initiatePaymentMethodSetup(payload) {
    var _a = serializer(_initiatePaymentMethodSetupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_initiatePaymentMethodSetupResponse, {}).fromJSON;
    function __initiatePaymentMethodSetup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsService.InitiatePaymentMethodSetup',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsServiceUrl({
                protoPath: '/v1/subscriptions/{id}/payment_method_setup',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __initiatePaymentMethodSetup.fromReq = fromReq;
    __initiatePaymentMethodSetup.__isAmbassador = true;
    return __initiatePaymentMethodSetup;
}
/** This used only for automation and permitted tenants (QA & testing) */
export function payCycle(payload) {
    var _a = serializer(_payCycleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_payCycleResponse, {
        _billingStatus: _billingStatus,
        _cancellationInfo: _cancellationInfo,
        _freeTrialData: _freeTrialData,
        _gracePeriodData: _gracePeriodData,
        _pauseInfo: _pauseInfo,
        _paymentData: _paymentData,
        _specificDateSubscriptionUpdateData: _specificDateSubscriptionUpdateData,
        _subscription: _subscription,
        _updateBillingDateData: _updateBillingDateData,
    }).fromJSON;
    function __payCycle(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsBackOfficeService.PayCycle',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsBackOfficeServiceUrl({
                protoPath: '/v1/subscriptions-bo/{subscriptionId}/pay-cycle',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __payCycle.fromReq = fromReq;
    __payCycle.__isAmbassador = true;
    return __payCycle;
}
/** This used only for automation and TestApp subscriptions only */
export function runTimeCapsuleTaskNow(payload) {
    var _a = serializer(_runTimeCapsuleTaskNowRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_empty, {}).fromJSON;
    function __runTimeCapsuleTaskNow(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.subscription',
            method: 'POST',
            methodFqn: 'com.wixpress.billing.subscriptions.api.v1.SubscriptionsBackOfficeService.RunTimeCapsuleTaskNow',
            url: resolveComWixpressBillingSubscriptionsApiV1SubscriptionsBackOfficeServiceUrl({
                protoPath: '/v1/subscriptions-bo/{subscriptionId}/run-task-now',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __runTimeCapsuleTaskNow.fromReq = fromReq;
    __runTimeCapsuleTaskNow.__isAmbassador = true;
    return __runTimeCapsuleTaskNow;
}
//# sourceMappingURL=http.impl.js.map